import React from "react";

const IframeWeb = ({ height, source }) => {
        return (
            // basic bootstrap classes. you can change with yours.
            <div className="col-md-12" style={{ padding: "0.5rem", marginTop: "0.5rem" }} >
                <div className="emded-responsive">
                    <iframe src={source}
                        width="100%" 
                        height={height} 
                        frameBorder="0"
                        allowFullScreen
                        title='embedded youtube'>
                    </iframe>
                </div>
            </div>
        );
};

    // const YoutubeEmbed = ({ embedId }) => (
    //     <div className="video-responsive">
    //         <iframe
    //         width="853"
    //         height="480"
    //         src={`https://www.youtube.com/embed/${embedId}`}
    //         frameBorder="0"
    //         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    //         allowFullScreen
    //         title="Embedded youtube"
    //         />
    //     </div>
    // );

    // YoutubeEmbed.propTypes = {
    //     embedId: PropTypes.string.isRequired
    // };

export default IframeWeb;